export const effects = {
  boxShadow: {
    large: '0px 24px 56px #0000000a',
    medium: '0px 12px 16px #0000000a',
    small: '0px 4px 6px #0000000a'
  },
  backdropFilter: {
    blur: 'blur(20px)'
  },
  background: {
    downward: 'linear-gradient(180deg, #ffffffbf 0%, #ffffff00 100%)',
    upward: 'linear-gradient(180deg, #ffffff00 0%, #ffffffbf 100%);'
  }
}
